import { DEACTIVATE_ROL, ACTIVATE_ROL, CREATE_ROL, UPDATE_ROL, GET_ERRORS, GET_ROLES } from './types';
import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';

const URL_GET_ROLES      = process.env.REACT_APP_API_URL + services.getRolByFilters;
const URL_DEACTIVATE_ROL = process.env.REACT_APP_API_URL + services.deactivateRol;
const URL_ACTIVATE_ROL   = process.env.REACT_APP_API_URL + services.activateRol;
const URL_UPDATE_ROL     = process.env.REACT_APP_API_URL + services.updateRol;
const URL_CREATE_ROL     = process.env.REACT_APP_API_URL + services.addRol;

export const getRoles = (params = null) => dispatch => {
	let url = URL_GET_ROLES;

	if(params){
		if(params.hasOwnProperty('is_active')){
			url += '?is_active=' + params.is_active;
		}
	}

	axios
		.get(url)
		.then(res => {
			dispatch({
				type: GET_ROLES,
				payload: {
					message: res.data.result
				}
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};

export const createRol = (name, description, key) => dispatch => {
	const data = {
			name,
			description,
			key
	}
	axios.post(URL_CREATE_ROL, data)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: CREATE_ROL,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)

			})
		});
}

export const updateRol = (id, name, description, key) => dispatch => {
	const data = {
    id,
    name,
    description,
    key
	}
	axios.patch(URL_UPDATE_ROL, data)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: UPDATE_ROL,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const activateRol = (id) => dispatch => {
	let url = URL_ACTIVATE_ROL + id;

	axios.patch(url)
		.then(res => {
			if (res.data.status.code === '0000')
				dispatch({
					type: ACTIVATE_ROL,
					payload: {
						message: res.data
					}
				})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
}

export const deactivateRol = (id) => dispatch => {
	axios
		.delete(URL_DEACTIVATE_ROL + id)
		.then(res => {
			dispatch({
				type: DEACTIVATE_ROL,
				payload: res.data
			})
		})
		.catch(error => {
			dispatch({
				type: GET_ERRORS,
				payload: getErrorMessage(error)
			})
		});
};